import { useQuery } from '@tanstack/react-query';

import { api } from './api';

export type DayMark =
  | { kind: 'absence'; type: string; status: 'APPROVED' | 'REQUESTED'; halfDay: boolean; id: string }
  | { kind: 'holiday'; name: string; halfDay: boolean }
  | { kind: 'off' };

export interface CalendarRow {
  employeeId: string;
  name: string;
  days: Record<number, DayMark>;
  byType: Record<string, number>;
  totalDays: number;
}

export interface AbsenceOverview {
  month: string;
  from: string;
  to: string;
  daysInMonth: number;
  /** 1 = Monday. */
  firstWeekday: number;
  rows: CalendarRow[];
}

/** One request behind both the calendar and the report. */
export const useAbsenceOverview = (month: string) =>
  useQuery({
    queryKey: ['absence', 'overview', month],
    queryFn: () => api.get<AbsenceOverview>(`/absence/overview?month=${month}`),
  });

export const ABSENCE_TYPES = ['VACATION', 'SICK', 'UNPAID', 'OTHER'] as const;

export const TYPE_LABEL: Record<string, string> = {
  VACATION: 'Vacation',
  SICK: 'Sick leave',
  UNPAID: 'Unpaid leave',
  OTHER: 'Other',
};

/**
 * The type colours, matching the notification emails.
 *
 * Written as literals rather than theme tokens because the same four colours
 * appear in mail, where there are no custom properties - if these two drift, a
 * vacation is teal on screen and orange in the inbox.
 */
export const TYPE_COLOR: Record<string, string> = {
  VACATION: '#008A5C',
  SICK: '#E8A33D',
  UNPAID: '#6B7280',
  OTHER: '#4B7BEC',
};
